import React from 'react'
import { Col, Row } from 'react-bootstrap'

const HomePathogenPanelTesting = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding10rem1 right-padding10rem1 p-top-bottom2rem1'>
            <div className='pb-3'>
            <center>
                <text className='fs-ss-32-1 text-montserrat fw-700 text-ss-primary'>
                    RESPIRATORY PATHOGEN PANEL TESTING
                </text>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </center>
            </div>

            <div className='pb-4'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black ' style={{ letterSpacing:'0.5px'}}>
                    <>The need for Respiratory Pathogen Panel Testing does not start and end with Covid-19. That is why we offer a large selection of on-site tests that help to improve your healthcare and enhance your comfort. With the latest technological equipment and highly trained staff, our professional testing labs ensure no stone is unturned on the path to reliable healthcare services for you. With a single easy swab test, 19 distinct viruses can be identified in less than 24 hours. Our tests are more accurate than 97% of the time. Are you ready to use our lab testing services because we are ready to provide you with reliable testing facilities in Chicagoland?</>
                </text>
            </div>

            <div className='pt-md-3'>
            {/* <center> */}
                <Row className=''>
                {/* <center> */}
                <Col md='4' className=''>
                    <text className='text-ss-secondary fw-600 text-montserrat display-block1 ms-2 mb-2' style={{ fontSize:'1.375rem'}}>
                        Viruses:
                    </text>
                    <ul className='fs-ss-16 text-montserrat fw-700 text-ss-black mb-0' style={{ letterSpacing:'0.5px', color:''}}>
                        <li className=''>Coronavirus 229E</li>
                        <li className=''>Coronavirus HKU1</li>
                        <li className=''>Coronavirus NL63</li>
                        <li className=''>Coronavirus OC43</li>
                        <li className=''>SARS-COV-2</li>
                        <li className=''>Human metapneumovirus</li>
                        <li className=''>Human Rhinovirus/ Enterovirus</li>
                        <li className=''>Adenovirus</li>
                        {/* <li className=''>Influenza A</li>
                        <li className=''></li> */}
                    </ul>
                    {/* </center> */}
                </Col>

                <Col md='4' className=''>
                    <ul className='fs-ss-16 text-montserrat fw-700 text-ss-black ' style={{ letterSpacing:'0.5px'}}>
                        <li className=''>Influenza A</li>
                        <li className=''>Influenza A subtypes (A/H1, A/H3)</li>
                        <li className=''>Influenza B</li>
                        <li className=''>Parainfluenza Virus 1</li>
                        <li className=''>Parainfluenza Virus 2</li>
                        <li className=''>Parainfluenza Virus 3</li>
                        <li className=''>Parainfluenza Virus 4</li>
                        <li className=''>Respiratory Syncytial virus</li>
                        {/* <li className=''></li>
                        <li className=''></li> */}
                    </ul>
                </Col>

                <Col md='4' className=''>
                <text className='text-ss-secondary fw-600 text-montserrat display-block1 ms-2 mb-2' style={{ fontSize:'1.375rem'}}>
                        Bacteria:
                    </text>
                    <ul className='fs-ss-16 text-montserrat fw-700 text-ss-black ' style={{ letterSpacing:'0.5px'}}>
                        <li className=''>Bordetella parapertussis</li>
                        <li className=''>Bordetella pertussis</li>
                        <li className=''>Chlamydia pneumoniae</li>
                        <li className=''>Mycoplasma</li>
                        <li className=''>Pneumonia</li>
                        <li className=''>H1, H3 and H1-2009</li>
                        {/* <li className=''></li>
                        <li className=''></li>
                        <li className=''></li>
                        <li className=''></li> */}
                    </ul>
                </Col>
            </Row>
            {/* </center> */}
            </div>
        </div>
    </div>
  )
}

export default HomePathogenPanelTesting